import { createFileRoute } from '@tanstack/react-router';
import { PublicQuotePage } from '@/features/public-quote';

/**
 * Public: the link of a quote email (`/q/{token}`). No session and no app shell: the page only
 * calls the public quote endpoints, and its code loads as its own chunk.
 */
export const Route = createFileRoute('/q/$token')({
  component: PublicQuoteRoute,
});

function PublicQuoteRoute() {
  const { token } = Route.useParams();
  return <PublicQuotePage token={token} />;
}
